export default __webpack_public_path__ + "static/media/woods.5b752663.jpg";